<template lang="html">
  <div ref="banner" class="cookie-banner" id="cookie-banner">
    <p>This site uses cookies to offer you a better browsing experience. Find out more on how we use cookies and how you can change your settings in our <router-link to="/cookies">Cookie Policy</router-link></p>
    <hr>
    <div class="flex">
        <button v-on:click="doNotAllow()" type="button">Don't allow cookies</button>
        <button v-on:click="allow()"      type="button">Allow cookies</button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  methods: {
    hideBanner: function() {
      // console.log('hide banner');
      this.$refs.banner.style.display = "none"
    },
    doNotAllow: function() {
      // console.log('do not track');

      // remove GA cookies
      if (this.$ga) {
        this.$Cookies.remove('_ga', {domain: document.location.hostname, path: '/'})
        this.$Cookies.remove('_ga_'+this.$ga.app.options.measurementId.slice(2,), {domain: document.location.hostname, path: '/'})
      }

      // block data transmit and cookie reinstallation
      this.$blockGA();

      // remember decision
      this.$Cookies.set("_cookie_banner", "do_not_allow", { expires: 180 });
      this.hideBanner();
    },
    allow: function() {
      // console.log('track');
      this.$Cookies.set("_cookie_banner", "allow", { expires: 180 });
      this.hideBanner();
      // window.location.reload(false)

      this.$unBlockGA();
      this.$initAnalytics();
    },
  },
  mounted() {
    if ([undefined, ''].indexOf(this.$Cookies.get("_cookie_banner")) == -1 ) {
      this.hideBanner();
    }
  }
}
</script>

<style lang="css" scoped>
.cookie-banner {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: #55ffcc;

	padding: 1rem 2rem;
	margin: 2.5rem;
  margin-bottom: 1rem;

	z-index: 100;
}
.flex {
  display: flex;
	justify-content: space-between;
	align-items: center;
	align-content: center;
}

a, p {
  color: #000;
}
p {
  margin: 0;
  max-width: none;
}
.message {
  margin-bottom: 1rem;
}
.label {
  margin: 0 1rem 0 0;
  text-align: right;
}

button {
  /* margin: 0 0 0 1rem; */
  /* width: 32%; */

  border: none;
  padding: 0.5rem 1rem;
  text-decoration: none;
  /* border-radius: 0.5rem; */
  background-color: #007bff;
  color: #fff;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
}
button:hover {
  background-color: #fff;
  color: #ff0130;
}
button + button {
  margin-left: 1rem;
}
.close-banner {
  margin-right: auto;
}
hr {
  background-color: rgba(0,0,0, 0.2);
}
</style>
